import apiClient from '@/services/axios'

export async function post(payload) {
  var response = await apiClient.post('/catchoffers/' + payload.type, {offers: payload.offer})
  if (response) {
    return response.data
  }

  throw new Error('Unable to upsert catch offers')
}